import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { getSuperGroupName } from '../utils/getSuperGroupName';

const sanitizeFileName = (name) => name.replace(/[\\/:*?"<>|]/g, '-');

const buildShortHeaderRows = (reportTitle, collectionMonth, printingTime) => ([
  ['MEDIPLUS MEDICAL SERVICES (Pvt) LTD.'],
  [reportTitle],
  [`Collection Month: ${collectionMonth}`],
  [`Printing Time: ${printingTime}`],
  [],
]);

const exportCollectionToExcel = (superGroups, orders, options = {}) => {
  if (!Array.isArray(orders) || orders.length === 0) {
    toast.error('No orders to export');
    return;
  }

  try {
    const workbook = XLSX.utils.book_new();
    const mode = options?.mode;

    if (mode === 'daily-short' || mode === 'monthly-short') {
      const rows = Array.isArray(orders) ? orders : [];
      const firstDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt) : moment();
      const collectionMonth = firstDate.format('MMMM YYYY');
      const printingTime = moment().format('hh:mm A');
      const reportTitle = options?.reportTitle || (mode === 'monthly-short' ? 'Monthly Collection Short' : 'Daily Collection Short');

      let tableHeader = [];
      let tableRows = [];
      let totalRow = [];

      if (mode === 'monthly-short') {
        const daysInMonth = firstDate.daysInMonth();
        const dayTotals = Array.from({ length: daysInMonth }, () => ({ paid: 0, due: 0, total: 0 }));
        let overallPaid = 0;
        let overallDue = 0;
        let overallTotal = 0;

        rows.forEach(order => {
          if (!order.createdAt) return;
          const d = moment(order.createdAt);
          const dayIndex = d.date() - 1;
          const paid = Number(order.paidAmount || 0);
          const due = Number(order.dueAmount || 0);
          const total = Number(order.totalAmount || 0);
          dayTotals[dayIndex].paid += paid;
          dayTotals[dayIndex].due += due;
          dayTotals[dayIndex].total += total;
          overallPaid += paid;
          overallDue += due;
          overallTotal += total;
        });

        tableHeader = ['Day', 'Advanced', 'Due', 'Total'];
        tableRows = dayTotals.map((dt, idx) => [idx + 1, dt.paid, dt.due, dt.total]);
        totalRow = ['Total', overallPaid, overallDue, overallTotal];
      } else {
        let sumPaid = 0;
        let sumDue = 0;
        let sumTotal = 0;
        tableHeader = ['Advanced', 'Due', 'Total'];
        tableRows = rows.map(order => {
          const paid = Number(order.paidAmount || 0);
          const due = Number(order.dueAmount || 0);
          const total = Number(order.totalAmount || 0);
          sumPaid += paid;
          sumDue += due;
          sumTotal += total;
          return [paid, due, total];
        });
        totalRow = [sumPaid, sumDue, sumTotal];
      }

      const headerRows = buildShortHeaderRows(reportTitle, collectionMonth, printingTime);
      const sheetRows = [...headerRows, tableHeader, ...tableRows, totalRow];
      const collectionSheet = XLSX.utils.aoa_to_sheet(sheetRows);
      XLSX.utils.book_append_sheet(workbook, collectionSheet, reportTitle);

      const fileName = sanitizeFileName(`${reportTitle} - ${collectionMonth}.xlsx`);
      XLSX.writeFile(workbook, fileName);
      toast.success('Excel file exported successfully');
      return;
    }

    const sheetData = orders.map(order => {
      const row = {};
      row['Date'] = order.createdAt ? new Date(order.createdAt).toLocaleDateString() : '';
      row['Order ID'] = order.testOrderID || '';
      row['Remarks'] = order.paymentType || '';

      let total = 0;
      if (Array.isArray(superGroups)) {
        superGroups.forEach(sg => {
          const val = order.tests && order.tests[sg] ? (order.tests[sg] || 0) : 0;
          row[getSuperGroupName(sg)] = val;
          total += Number(val) || 0;
        });
      }

      row['Total'] = total;
      row['End Date'] = order.lastPaymentDate ? new Date(order.lastPaymentDate).toLocaleDateString() : '';
      return row;
    });

    const collectionSheet = XLSX.utils.json_to_sheet(sheetData);
    XLSX.utils.book_append_sheet(workbook, collectionSheet, 'Daily Collection');

    const fileName = `Daily_Collection_${new Date().toISOString().slice(0,10)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    toast.success('Excel file exported successfully');
  } catch (err) {
    console.error('Export to Excel failed:', err);
    toast.error('Failed to export Excel file');
  }
};

export default exportCollectionToExcel;